import script from "./LandingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingPage.vue?vue&type=script&setup=true&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=11403966&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11403966"]])

export default __exports__